import { useMemo } from 'react'
import _ from 'lodash'

import { useGetFilteredToursWithException } from './useGetFilteredToursWithException'

export function useGetMaxValueOfToursField(fieldKey, localFilterState = {}) {
  const tours = useGetFilteredToursWithException(fieldKey, localFilterState)
  return useMemo(() => {
    let max = 0 ;
    _.forEach(tours, tour => {
      const fieldValue = _.get(tour, `[${fieldKey}]`)
      if (Number.isInteger(fieldValue) && fieldValue > max) {
        max = fieldValue
      }
    })
    return max
  }, [fieldKey, tours])
}
